import { AfterViewInit, Component, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { FusionAuthService } from '../../../../../shared/services/fusion-auth';
import { ClientService } from '../../../../shared/services';
import { SettingsService } from '../../../../shared/services/settings.service';

@Component({
    selector: 'app-advanced-search',
    templateUrl: './advanced-search.component.html',
    styleUrls: ['./advanced-search.component.scss'],
})
export class AdvancedSearchComponent implements AfterViewInit, OnDestroy {
    @Output() public formSubmitted = new EventEmitter();
    public resultsSearchForm: FormGroup;
    private sent = false;
    public role: string = '';
    public isLoading = false;
    public showMissingInfo = false;

    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(
        private fb: FormBuilder,
        private fusionAuthService: FusionAuthService,
        private clientService: ClientService,
        private settingsService: SettingsService,
    ) {
        this.resultsSearchForm = this.fb.group({
            status: [null],
            missingInfo: [false],
            criticalResults: [false],
        });

        this.initialSubmit = this.initialSubmit.bind(this);
    }

    public ngAfterViewInit(): void {
        this.settingsService
            .IsMissingInfoEnabled()
            .pipe(take(1))
            .subscribe(x => {
                this.showMissingInfo = x;
            });

        this.initialSubmit();
    }

    private initialSubmit() {
        if (localStorage.getItem('authtoken')) {
            this.role = this.fusionAuthService.Profile.registrations[0].roles[0];

            if (!this.sent) {
                this.submit();
                this.sent = true;
            }
            this.isLoading = false;
        } else {
            this.isLoading = true;
            of()
                .pipe(
                    take(1),
                    debounceTime(1000),
                )
                .subscribe(() => this.initialSubmit());
        }
    }

    public clear() {
        this.resultsSearchForm.reset();
        this.submit();
    }

    public searchResults(): void {
        if (this.resultsSearchForm.valid) {
            this.submit();
        }
    }

    private submit() {
        this.formSubmitted.emit(this.resultsSearchForm.value);
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
